import React, { useEffect } from 'react'

function FileUploadCompletion(props) {

    const loadingBarRef = React.useRef();

    useEffect(() => {
        loadingBarRef.current.style.width = props.percentComplete + '%';
    }, [props.percentComplete]);

    return (
        <React.Fragment>
            <p/>
            <div className="row justify-content-center">
                <div className="col-8 col-xl-4 customBorder">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            Upload: <span className="noticeNormal">{props.percentComplete}%</span>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="loadingBarBorder">
                                <div id="loadingBar2" className="loadingBar" ref={loadingBarRef}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default FileUploadCompletion
